// Category count functions
export function updateCategoryCounts(activeCategories, posts) {
  const categoryCounts = getCategoryCounts(posts);

  const categories = activeCategories.map(category => ({
    name: category.name,
    checked: category.checked,
    count: categoryCounts[category.name] ? categoryCounts[category.name] : 0
  }))

  return categories
}

function processPost(counts, post) {
  const categoryName = post.frontmatter.category

  counts[categoryName] = counts[categoryName] ? counts[categoryName]+1 : 1

  return counts
}

function getCategoryCounts(posts) {
  return posts.reduce(processPost, {})
}


// Matching functions
function matchStringBySubString(string, subString) {
  return string.toLowerCase().includes(subString.toLowerCase())
}

export function matchesKeyword(searchTerm) {
  return function (post) {
    return  matchStringBySubString(post.frontmatter.excerpt, searchTerm) ||
      matchStringBySubString(post.frontmatter.title, searchTerm) ||
        matchStringBySubString(post.frontmatter.category, searchTerm)
    }
}

export function matchesCategories(filterByCategories) {
  return function (post) {
    return filterByCategories.includes(post.frontmatter.category)
  }
}

// Category check/uncheck functions
export function checkUncheckCategory(categoryToChange, oldCategories) {
  const newCategories = oldCategories.map( category => {
    if (category.name === categoryToChange) {
      return {
        ...category,
        checked: !category.checked
      }
    }

    return category
  })

  return newCategories;
}

export function uncheckAllCategories(categoryToChange, oldCategories) {
  const newCategories = oldCategories.map( category => {
    return {...category, checked: false}
  })

  return newCategories;
}

// Return active categories functions
export function getCategoryIfTrue(activeCategories, category) {
  if (category.checked) {
    activeCategories.push(category.name)
  }

  return activeCategories;
}

export function countActiveCategories(categories) {
  return categories.filter(category => category.checked).length
}

function closeFilterMenu() {
  document.removeEventListener('keydown', trapFocus)
  document.querySelector('.js-open-filter-menu').focus()
}

function trapFocus(e) {
  const firstFocusableEl = document.querySelector('.js-close-filter-menu')
  const lastFocusableEl = document.querySelector('.js-filter-list > li:last-child input')

  if (e.keyCode === 9) {
   //Rotate Focus
   if (e.shiftKey && document.activeElement === firstFocusableEl) {
     e.preventDefault();
     lastFocusableEl.focus();
   } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
     e.preventDefault();
     firstFocusableEl.focus();
   }
 } else if (e.keyCode === 27) {
   toggleMobileMenu(false)
 }
}

// toggle mobile filter menu on/off and adjust focus
function resetFilterMenuFocus(isOpen) {
  if (isOpen) {
    document.addEventListener('keydown', trapFocus)
    document.querySelector('.js-filter-container').focus()
    return
  }

  closeFilterMenu()
}

export function toggleMobileMenu(isOpen) {
  const filterBackdrop = document.querySelector('.js-filter-backdrop')
  const filterContainer = document.querySelector('.js-filter-container')
  filterContainer.classList.toggle('filter__container--visible')
  filterBackdrop.classList.toggle('filter__backdrop--visible')

  resetFilterMenuFocus(isOpen);
}
